<script setup>
/**
 * @fileoverview "Download Your Custom Specs" — opens the specs PDF of the
 * current design (pdf.fireclaytile.com rendering the `?print=1` sheet).
 *
 * @component
 */
import { computed } from 'vue';
import { useMosaicStore } from '../stores/mosaicStore';
import { specsPdfUrl } from '../utils/handOff.js';
import { trackSpecsDownload } from '../utils/trackingService';
import { ArrowDownTrayIcon } from '@heroicons/vue/24/outline';

const store = useMosaicStore();

const href = computed(() =>
    store.selectedPattern && store.shareUrl
        ? specsPdfUrl(store.shareUrl, store.selectedPattern.id)
        : '',
);
</script>

<template>
    <a
        v-if="href"
        :href="href"
        target="_blank"
        rel="noopener"
        class="px-2 py-1.5 md:px-4 md:py-3 rounded-[50px] border border-dryline bg-dryline text-white hover:bg-dryline-400 inline-flex items-center gap-2 text-[10px] md:text-xs font-body uppercase leading-tight tracking-wide"
        data-testid="download-specs"
        @click="trackSpecsDownload(store.selectedPatternId, store.paintedCount)"
    >
        <ArrowDownTrayIcon class="w-3.5 h-3.5 md:w-4 md:h-4" aria-hidden="true" />
        Download Your Custom Specs
        <span class="sr-only">(PDF, opens in a new tab)</span>
    </a>
</template>
